import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntersectionObserver } from '@grandvisionhq/lib-utils-react';
import Picture from '../Picture/Picture.js';

const LazyPicture = ({ image , mobileImage , className , imgSizes , showImageAsCover ,  })=>{
    const isPhone = MediaQuery.useIsPhone();
    const { h , w  } = isPhone && mobileImage ? mobileImage.dimensions : image.dimensions;
    const [ref, inView] = useIntersectionObserver({
        rootMargin: '150px 0px',
        freezeOnceVisible: true
    });
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: classnames('lazy-picture', {
            'lazy-picture--loaded': inView
        }, className),
        style: showImageAsCover ? undefined : {
            paddingBottom: `${(h / w * 100).toFixed(3)}%`
        }
    }, inView && /*#__PURE__*/ React.createElement(Picture, {
        className: "lazy-picture__image",
        mobileUrl: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url,
        url: image.url,
        height: h,
        width: w,
        alt: image.alt,
        imgSizes: imgSizes,
        showImageAsCover: showImageAsCover
    }));
};

export { LazyPicture as default };
//# sourceMappingURL=LazyPicture.js.map
